import {Injectable} from '@angular/core';
import {HttpClient} from "@angular/common/http";
import {Observable} from "rxjs";
import {environment} from '../../env';
import {map} from "rxjs/operators";

@Injectable({
  providedIn: 'root'
})
export class BarcodeService {

  constructor(private http: HttpClient) {
  }

  getBarcodeImageUrl(code: string, width: number, height: number): Observable<string> {
    return this.http.get(`${environment.apiUrl}/barcodes/${code}/image?w=${width}&h=${height}`, {responseType: 'blob'}).pipe(
      map(blob => URL.createObjectURL(blob))
    );
  }

}
